import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebase";
export const portalCall = (method, data = {}) =>
  httpsCallable(getFunctions(app, "europe-west2"), `portal${method}`, {
    timeout: 120000,
  })(data).then((result) => result.data);
export const money = (pence) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(
    (pence || 0) / 100,
  );
export const dateLabel = (day) =>
  new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(new Date(`${day}T12:00:00Z`));
export const localInput = (value) =>
  value
    ? new Intl.DateTimeFormat("sv-SE", {
        timeZone: "Europe/London",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      })
        .format(new Date(value))
        .replace(" ", "T")
    : "";
export const csvCell = (value) => {
  let text = String(value ?? "");
  if (/^[\s]*[=+\-@]/.test(text)) text = "'" + text;
  return `"${text.replace(/"/g, '""')}"`;
};
export function downloadBytes(base64, name, type = "application/pdf") {
  const raw = atob(base64),
    bytes = Uint8Array.from(raw, (c) => c.charCodeAt(0)),
    url = URL.createObjectURL(new Blob([bytes], { type }));
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
